export const MIN_SUGGESTED_PRODUCTS = 5;
export const MIN_SUGGESTED_KEYWORDS = 4;
export const MIN_SUGGESTED_CITIES = 10;
export const MIN_SUGGESTED_KEYWORDS_FOR_BROAD = 10;
export const Phrases = {
    MIN_CITIES: `Add atleast ${MIN_SUGGESTED_CITIES} or more cities in your campaign for the Ad to reach more users`,
    MIN_PRODUCTS: `Add atleast ${MIN_SUGGESTED_PRODUCTS} or more products in your campaign for the Ad to reach more users`,
    MIN_KEYWORDS: `Select ${MIN_SUGGESTED_KEYWORDS} or more keywords to reach a wider audience`,
    BROAD_KEYWORD: 'Add atleast 1 Broad Match keyword to reach a wider audience',
    REVIEW_PAGE: 'Some minimum conditions are not met & may hamper visibility of your ads',
    SUBMIT_CAMPAIGN_MODAL_TITLE: 'Some minimum conditions are not met',
    SUBMIT_CAMPAIGN_MODAL_SUBTITLE: 'Are you sure you to submit the campaign without making the changes suggested by us?',
    HOME_PAGE_BURNOUT_KEYWORD: 'Budget exhausted of the following campaigns. To continue getting impressions kindly update the budget',
};
export const MAX_BURNOUT_ITEMS = 5;
